var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-page"},[(_vm.hasSelectedInspection)?_c('section',{staticClass:"sidebar-layout"},[_c('SideBar'),_c('router-view',{staticClass:"sidebar-content mr-5"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }